export default {"item":"bwsYEW_item","wrapper":"bwsYEW_wrapper","group":"bwsYEW_group",}